export default function Thanks(){
return(
    <div>
        Thank you very much for shopping with us, we will be happy to see you again
    </div>
)
}